// extracted by mini-css-extract-plugin
export default {"policy-container":"PrivacyPolicyPopup_policy-container__-84hH","title":"PrivacyPolicyPopup_title__Pdl03","content":"PrivacyPolicyPopup_content__bfCPl"};